// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N1xW","footer":"styles_footer__3_uXp","passCodeTooltip":"styles_passCodeTooltip__2mQzz"};